/* GIN Hair unified product card: add to cart */
(function () {
  if (window.__ginCardBound) return;
  window.__ginCardBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button.gin-card__atc[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'gin-card', data: { source: 'gin-card', itemCount: cart.item_count, variantId: String(variantId) } }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      });
  });
})();
